import React, { useContext, useEffect, useState } from "react";
import { FaCalendarAlt, FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import { FcSalesPerformance } from "react-icons/fc";
import { Button, Card, Col, Container, Row, Table } from "react-bootstrap";
import { Bar, Line, Pie } from "react-chartjs-2";
import Select from "react-select";

import swal from "sweetalert";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { IoIosAlert } from "react-icons/io";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

export const Dashboard2026 = ({ year }) => {
  const performanceData = {
    labels: [
      "Technical Skills",
      "Problem-Solving",
      "Teamwork",
      "Innovation",
      "Punctuality",
    ],
    datasets: [
      {
        label: "Performance Score",
        data: [85, 90, 75, 80, 95],
        backgroundColor: "#82ca9d",
      },
    ],
  };

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [projects, setProjects] = useState([]);
  const [Projectdata, setProjectdata] = useState([]);

  const [attendanceData, setAttendanceData] = useState([]);
  const GetAttendancePercentage = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAttendancePercentage`,
        requestOptions
      );
      const responseData = await res.json();

      if (responseData.status === "0" && responseData.data.length > 0) {
        // Extract attendance data for the chart
        const rawData = responseData.data[0];
        const formattedData = Object.keys(rawData)
          .filter(
            (key) => key !== "id" && key !== "empid" && rawData[key] !== null
          )
          .map((key) => ({
            month: key,
            percentage: parseInt(rawData[key], 10),
          }));

        setAttendanceData(formattedData);
      }

      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setTransactionLoaderState(false);
    }
  };

  const GetProjectOwner = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetProjectOwner`,
        requestOptions
      );
      const result = await res.json();
      if (result.status === "0") {
        setProjects(result.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setTransactionLoaderState(false);
    }
  };
  const fetchproject = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: user.userid,
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetProjectByEmployee`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        const uniqueProjectIds = [
          ...new Set(data.data.map((project) => project.pk_project_id)),
        ];
        setProjectdata(data.data);
        GetProjectAnalytics(uniqueProjectIds); // Pass the extracted project IDs
      }
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };

  const GetProjectAnalytics = async (projectIds) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      // Loop through each project ID and fetch analytics
      const analyticsData = await Promise.all(
        projectIds.map(async (projectId) => {
          var raw = JSON.stringify({
            empid: user.userid,
            firmid: user.firm_id,
            projectid: projectId,
          });

          var requestOptions = {
            method: "POST",
            headers: {
              Authorization: `Basic ${base64Credentials}`,
              "Content-Type": "application/json",
            },
            body: raw,
            redirect: "follow",
          };

          const res = await fetch(
            `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetProjectAnalytics`,
            requestOptions
          );
          return res.json();
        })
      );

      // Extract only the successful responses
      const validData = analyticsData
        .filter((item) => item.status === "0")
        .flatMap((item) => item.data);

      setProjectdata(validData);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  const chartData = {
    labels: attendanceData.map((item) => item.month), // X-axis labels
    datasets: [
      {
        label: "Attendance Percentage",
        data: attendanceData.map((item) => item.percentage), // Y-axis data
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 25,
          suggestedMin: 0,
        },
      },
    },
  };

  useEffect(() => {
    GetAttendancePercentage();
    GetProjectOwner();
    fetchproject();
  }, []);
  return (
    <Container fluid className="mt-2">
      <Row>
        <Col md={6} className="pr-0">
          <Card className="p-3 shadow">
            <h5>Monthly Attendance</h5>
            <Bar data={chartData} options={options} />
          </Card>
        </Col>
        <Col md={6} className="pr-0">
          <Card className="p-3 shadow">
            <h5>Performance Metrics</h5>
            <Bar data={performanceData} />
          </Card>
        </Col>
      </Row>

      <Row className="">
        <Col md={6}>
          <Card
            className="p-2"
            style={{
              height: "45vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <h6 className="text-center">Project Details</h6>
            {Projectdata.length > 0 ? (
              Projectdata.map((project) => (
                <div key={project.pk_project_id} className="mb-2">
                  <h6>{project.project_name}</h6>
                  <Row className="p-0 m-0">
                    {" "}
                    <p className="col-8 m-0 p-0">
                      <strong>Owner:</strong> {project.project_ownership}
                    </p>
                    <p className="col-4 m-0 p-0 ">
                      <strong>Start Date:</strong>{" "}
                      {new Date(
                        project.project_startdate
                      ).toLocaleDateString() || "NA"}{" "}
                    </p>
                  </Row>
                  <Row className="p-0 m-0">
                    {" "}
                    <p className="col-8 m-0 p-0">
                      <strong>
                        <IoCheckmarkDoneCircleSharp
                          style={{ color: "green", fontSize: "1rem" }}
                        />{" "}
                        Completed On Time:
                      </strong>{" "}
                      {project.completedOntime}&nbsp;Task
                    </p>
                    <p className="col-4 m-0 p-0 ">
                      <strong>
                        {" "}
                        <IoIosAlert
                          style={{ color: "red", fontSize: "1rem" }}
                        />
                        Overdue:
                      </strong>{" "}
                      {project.overdue}
                    </p>
                  </Row>

                  <hr className="m-2" />
                </div>
              ))
            ) : (
              <p className="text-center">No project data available</p>
            )}
          </Card>
        </Col>

        <Col md={6}>
          <Card
            className="p-2"
            style={{
              height: "45vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <h6 className="text-center">Project Details</h6>
            {projects.map((project) => (
              <div key={project.pk_project_id}>
                <h5 className="mb-2">{project.project_name}</h5>

                <Row className="p-0 m-0">
                  {" "}
                  <p className="col-8 m-0 p-0">
                    <strong>Owner:</strong> {project.project_ownership}
                  </p>
                  <p className="col-4 m-0 p-0 ">
                    <strong>Start Date:</strong>{" "}
                    {new Date(project.project_startdate).toLocaleDateString() ||
                      "NA"}{" "}
                  </p>
                </Row>
                {/* <p><strong>End Date:</strong> {project.project_enddate}</p> */}
                <p className="">
                  <strong>Description:</strong> {project.project_discription}
                </p>
                <hr className="m-1" />
              </div>
            ))}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export const Mcq2026 = ({ year }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [mcqData, setMcqData] = useState([]);
  const decodeText = (text) => {
    return decodeURIComponent(text.replace(/â€™/g, "’"));
  };
  const GetMCQTechQa = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empId: user.userid,
          year: year,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetMCQTechQa`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        const mappedData = data.data.map((item) => ({
          question_id: item.rowNumber,
          question_text: item.question,
          optionA: item.optionA,
          optionB: item.optionB,
          optionC: item.optionC,
          optionD: item.optionD,
        }));
        const prefilledAnswers = await GetPrefilledAnswers();

        setMcqData(mappedData);
        setSelectedAnswers(prefilledAnswers);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };
  const [selectedAnswers, setSelectedAnswers] = useState({});

  const handleOptionChange = (questionId, selectedOption) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: selectedOption,
    }));
  };

  const InsertAppraisalAnswer = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const requests = Object.entries(selectedAnswers)
        .filter(
          ([_, answer]) =>
            answer !== null && answer !== undefined && answer !== ""
        )
        .map(([questionId, answer]) => ({
          questionid: questionId.toString(),
          answer,
        }));

      if (requests.length === 0) {
        swal("Warning", "Please answer at least one question", "warning");
        setTransactionLoaderState(false);
        return;
      }

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          empid: user.userid,
          type: "1",
          requests: requests,
        }),
      };
      console.log(requests);
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/InsertTechQA`,
        requestOptions
      );

      const responseData = await res.json();

      if (responseData.status === "0") {
        swal("Success", responseData.result || responseData.msg, "success");
      } else {
        swal(
          "Error",
          responseData.result || responseData.msg || "Failed to save answers",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting answers:", error);
      swal("Error", "Something went wrong. Please try again.", "error");
    }
    setTransactionLoaderState(false);
  };
  const GetPrefilledAnswers = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/getAllQaAnswer`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empid: user.userid,
            type: "1",
          }),
        }
      );
  
      const data = await res.json();
  
      if (data.status === "0" && data.data) {
       const answerMap = {};
        data.data.forEach((item) => {
          answerMap[item.question_id] = item.answer;
        });
  
        return answerMap;
      }
    } catch (error) {
      console.error("Error fetching prefilled answers:", error);
    }
    return {};
  };
  useEffect(() => {
    GetMCQTechQa();
  }, []);
  return (
    <div className="m-2">
      <h5 className="mb-0">Technical Evaluation</h5>

      <div>
        {mcqData.length > 0 ? (
          mcqData.map((question, index) =>
            index % 2 === 0 ? (
              <div className="row pb-0 pt-0" key={question.question_id}>
                <div className="col-md-6 p-2">
                  <label className="form-label" style={{ fontSize: ".9rem" }}>
                    {decodeText(question.question_text)}
                  </label>

                  <div>
                    {["A", "B", "C", "D"].map((opt) => (
                      <div key={opt} style={{ fontSize: ".9rem" }}>
                        <input
                          type="radio"
                          name={`q${question.question_id}`}
                          value={opt}
                          onChange={() =>
                            handleOptionChange(question.question_id, opt)
                          }
                          checked={
                            selectedAnswers[question.question_id] === opt
                          }
                        />{" "}
                        {question[`option${opt}`]}
                      </div>
                    ))}
                  </div>
                </div>

                {mcqData[index + 1] && (
                  <div className="col-md-6 p-2">
                    <label className="form-label" style={{ fontSize: ".9rem" }}>
                      {decodeText(mcqData[index + 1].question_text)}
                    </label>

                    <div>
                      {["A", "B", "C", "D"].map((opt) => (
                        <div key={opt} style={{ fontSize: ".9rem" }}>
                          <input
                            type="radio"
                            name={`q${mcqData[index + 1].question_id}`}
                            value={opt}
                            onChange={() =>
                              handleOptionChange(
                                mcqData[index + 1].question_id,
                                opt
                              )
                            }
                            checked={
                              selectedAnswers[
                                mcqData[index + 1].question_id
                              ] === opt
                            }
                          />{" "}
                          {mcqData[index + 1][`option${opt}`]} {/* ✅ FIXED */}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : null
          )
        ) : (
          <p>No MCQs available.</p>
        )}
      </div>
      <div className="col d-flex" style={{ justifyContent: "space-between" }}>
        <Button
          size="sm"
          variant="success"
          className="mt-3"
          onClick={InsertAppraisalAnswer}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};
export const Selfreview2026 = ({ year }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [mcqData, setMcqData] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const decodeText = (text) => {
    return decodeURIComponent(text.replace(/â€™/g, "’"));
  };
  const GetSelfReviewTechQa = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empId: user.userid,
          year: year,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetSelfReviewTechQa`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        const mappedData = data.data.map((item) => ({
          question_id: item.rowNumber,
          question_text: item.question,
          optionA: item.optionA,
          optionB: item.optionB,
          optionC: item.optionC,
          optionD: item.optionD,
        }));
        const prefilledAnswers = await GetPrefilledAnswers();

        setMcqData(mappedData);
        setSelectedAnswers(prefilledAnswers);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };
  const handleOptionChange = (questionId, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };
  const InsertAppraisalAnswer = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const requests = Object.entries(selectedAnswers)
        .filter(
          ([_, answer]) =>
            answer !== null && answer !== undefined && answer !== ""
        )
        .map(([questionId, answer]) => ({
          questionid: questionId.toString(),
          answer,
        }));

      if (requests.length === 0) {
        swal("Warning", "Please answer at least one question", "warning");
        setTransactionLoaderState(false);
        return;
      }

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          empid: user.userid,
          type: "3",
          requests: requests,
        }),
      };
      // console.log(requests);
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/InsertTechQA`,
        requestOptions
      );

      const responseData = await res.json();

      if (responseData.status === "0") {
        swal("Success", responseData.result || responseData.msg, "success");
      } else {
        swal(
          "Error",
          responseData.result || responseData.msg || "Failed to save answers",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting answers:", error);
      swal("Error", "Something went wrong. Please try again.", "error");
    }
    setTransactionLoaderState(false);
  };
  const GetPrefilledAnswers = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/getAllQaAnswer`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empid: user.userid,
            type: "3",
          }),
        }
      );
  
      const data = await res.json();
  
      if (data.status === "0" && data.data) {
       const answerMap = {};
        data.data.forEach((item) => {
          answerMap[item.question_id] = item.answer;
        });
  
        return answerMap;
      }
    } catch (error) {
      console.error("Error fetching prefilled answers:", error);
    }
    return {};
  };
  useEffect(() => {
    GetSelfReviewTechQa();
  }, []);

  return (
    <div className="m-2">
      <h5 className="mb-0">Self Evaluation</h5>
      <div className="">
        {mcqData.length > 0 ? (
          mcqData.map((question, index) => {
            if (index % 2 !== 0) return null;

            const secondQ = mcqData[index + 1];

            return (
              <div className="row pb-0 pt-0" key={question.question_id}>
                <div className="col-md-6 p-2">
                  <label className="form-label" style={{ fontSize: ".9rem" }}>
                    {decodeText(question.question_text)}
                  </label>
                  <div>
                    {["A", "B", "C", "D"].map((opt) => (
                      <div key={opt}>
                        <input
                          className="mx-2"
                          type="radio"
                          name={`q${question.question_id}`}
                          value={opt}
                          onChange={() =>
                            handleOptionChange(question.question_id, opt)
                          }
                          checked={
                            selectedAnswers[question.question_id] === opt
                          }
                        />
                        {question[`option${opt}`]}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Second Question */}
                {secondQ && (
                  <div className="col-md-6 p-2">
                    <label className="form-label" style={{ fontSize: ".9rem" }}>
                      {decodeText(secondQ.question_text)}
                    </label>
                    <div>
                      {["A", "B", "C", "D"].map((opt) => (
                        <div key={opt}>
                          <input
                            className="mx-2"
                            type="radio"
                            name={`q${secondQ.question_id}`}
                            value={opt}
                            onChange={() =>
                              handleOptionChange(secondQ.question_id, opt)
                            }
                            checked={
                              selectedAnswers[secondQ.question_id] === opt
                            }
                          />
                          {secondQ[`option${opt}`]}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <p>No MCQs available.</p>
        )}
      </div>
      {/* Submit Button */}
      <button className="btn btn-primary mt-3" onClick={InsertAppraisalAnswer}>
        Submit
      </button>
    </div>
  );
};
export const Firmreview2026 = ({ year }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;

  const [mcqData, setMcqData] = useState([]);
  const [answers, setAnswers] = useState({});

  const decodeText = (text) => {
    return decodeURIComponent(text.replace(/â€™/g, "’"));
  };
  const GetAppraisalCompany = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empId: user.userid,
          year: year,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetFirmReviewTechQa`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        const mappedData = data.data.map((item) => ({
          question_id: item.rowNumber,
          question_text: item.question,
        }));
        const prefilledAnswers = await GetPrefilledAnswers();

        setMcqData(mappedData);
        setAnswers(prefilledAnswers);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching MCQ questions:", error);
      setTransactionLoaderState(false);
    }
  };


  const InsertAppraisalAnswer = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requests = Object.entries(answers)
        .filter(([_, answer]) => answer && answer.trim() !== "")
        .map(([questionId, answer]) => ({
          questionid: questionId.toString(),
          answer: answer.trim(),
        }));

      if (requests.length === 0) {
        swal("Warning", "Please answer at least one question", "warning");
        return;
      }

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/InsertTechQA`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empid: user.userid,
            type: "4",
            requests: requests,
          }),
        }
      );

      const responseData = await res.json();

      if (responseData.status === "0") {
        swal("Success", responseData.result || responseData.msg, "success");
      } else {
        swal(
          "Error",
          responseData.result || responseData.msg || "Failed to save answers",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting answers:", error);
      swal("Error", "Something went wrong. Please try again.", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const GetPrefilledAnswers = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/getAllQaAnswer`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empid: user.userid,
            type: "4", 
          }),
        }
      );
  
      const data = await res.json();
  
      if (data.status === "0" && data.data) {
        const answerMap = {};
        data.data.forEach((item) => {
          answerMap[item.question_id] = item.answer;
        });
  
        return answerMap;
      }
    } catch (error) {
      console.error("Error fetching prefilled answers:", error);
    }
  
    return {};
  };
  useEffect(() => {
    if (year) {
      GetAppraisalCompany();
    }
  }, [year]);


  const handleInputChange = (questionId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };


  return (
    <div className="m-2">
      <h5 className="mb-0">Firm Review</h5>
      <div>
        {mcqData.length > 0 ? (
          mcqData.map((question, index) => {
            if (index % 2 === 0) {
              return (
                <div className="row" key={question.question_id}>
                  {/* LEFT COLUMN */}
                  <div className="col-md-6 p-2">
                    <label className="form-label" style={{ fontSize: ".9rem" }}>
                      {decodeText(question.question_text)}
                    </label>

                    <textarea
                    className="form-control"
                    rows={3} 
                      placeholder="Your answer..."
                      value={answers[question.question_id] || ""}
                      onChange={(e) =>
                        handleInputChange(question.question_id, e.target.value)
                      }
                    />
                  </div>

                  {/* RIGHT COLUMN */}
                  {mcqData[index + 1] && (
                    <div className="col-md-6 p-2">
                      <label
                        className="form-label"
                        style={{ fontSize: ".9rem" }}
                      >
                        {decodeText(mcqData[index + 1].question_text)}
                      </label>

                      <textarea
                    className="form-control"
                    rows={3} 
                        placeholder="Your answer..."
                        value={answers[mcqData[index + 1].question_id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            mcqData[index + 1].question_id,
                            e.target.value
                          )
                        }
                      />
                    </div>
                  )}
                </div>
              );
            }
            return null;
          })
        ) : (
          <p>No questions available.</p>
        )}
      </div>
      <button className="btn btn-primary mt-3" onClick={InsertAppraisalAnswer}>
        Submit Answers
      </button>
    </div>
  );
};
export const Technical2026 = ({ year }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;

  const [mcqData, setMcqData] = useState([]);
  const [answers, setAnswers] = useState({});

  const decodeText = (text) => {
    return decodeURIComponent(text.replace(/â€™/g, "’"));
  };

  const GetAppraisalCompany = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetTechQa`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empId: user.userid,
            year: year,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "0" && data.data) {
        const mappedData = data.data.map((item) => ({
          question_id: item.rowNumber,
          question_text: item.question,
        }));
        const prefilledAnswers = await GetPrefilledAnswers();

        setMcqData(mappedData);
        setAnswers(prefilledAnswers);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const InsertAppraisalAnswer = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requests = Object.entries(answers)
        .filter(([_, answer]) => answer && answer.trim() !== "")
        .map(([questionId, answer]) => ({
          questionid: questionId.toString(),
          answer: answer.trim(),
        }));

      if (requests.length === 0) {
        swal("Warning", "Please answer at least one question", "warning");
        return;
      }

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/InsertTechQA`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empid: user.userid,
            type: "2",
            requests: requests,
          }),
        }
      );

      const responseData = await res.json();

      if (responseData.status === "0") {
        swal("Success", responseData.result || responseData.msg, "success");
      } else {
        swal(
          "Error",
          responseData.result || responseData.msg || "Failed to save answers",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting answers:", error);
      swal("Error", "Something went wrong. Please try again.", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const GetPrefilledAnswers = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
  
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/getAllQaAnswer`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            empid: user.userid,
            type: "2", 
          }),
        }
      );
  
      const data = await res.json();
  
      if (data.status === "0" && data.data) {
        const answerMap = {};
        data.data.forEach((item) => {
          answerMap[item.question_id] = item.answer;
        });
  
        return answerMap;
      }
    } catch (error) {
      console.error("Error fetching prefilled answers:", error);
    }
  
    return {};
  };
  useEffect(() => {
    GetAppraisalCompany();
  }, []);

  const handleInputChange = (questionId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  return (
    <div className="m-2">
      <h5 className="mb-2">Technical</h5>

      <div>
        {mcqData.length > 0 ? (
          mcqData.map((question, index) => {
            if (index % 2 === 0) {
              return (
                <div className="row" key={question.question_id}>
                  {/* LEFT COLUMN */}
                  <div className="col-md-6 p-2">
                    <label className="form-label" style={{ fontSize: ".9rem" }}>
                      {decodeText(question.question_text)}
                    </label>

                    <textarea
                    className="form-control"
                    rows={5} 
                      placeholder="Your answer..."
                      value={answers[question.question_id] || ""}
                      onChange={(e) =>
                        handleInputChange(question.question_id, e.target.value)
                      }
                    />
                  </div>

                  {/* RIGHT COLUMN */}
                  {mcqData[index + 1] && (
                    <div className="col-md-6 p-2">
                      <label
                        className="form-label"
                        style={{ fontSize: ".9rem" }}
                      >
                        {decodeText(mcqData[index + 1].question_text)}
                      </label>

                      <textarea
                    className="form-control"
                    rows={5} 
                        placeholder="Your answer..."
                        value={answers[mcqData[index + 1].question_id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            mcqData[index + 1].question_id,
                            e.target.value
                          )
                        }
                      />
                    </div>
                  )}
                </div>
              );
            }
            return null;
          })
        ) : (
          <p>No questions available.</p>
        )}
      </div>

      <button className="btn btn-primary mt-3" onClick={InsertAppraisalAnswer}>
        Submit Answers
      </button>
    </div>
  );
};
